import { getLanguageName } from "./languages.js"

export const getGPTPrompt = (taskName, taskInputType, targetLang) => {
	if (!taskName || !taskInputType) {
		return null
	}

	if (taskName === "translate" && !targetLang) {
		return null
	}

	if (taskName === "reword") {
		if (taskInputType === "title") {
			return "Your job is to reword the following product title to make it more appealing to customers. The return format should be a string. Do not return quotes as part of the response. Return the reworded product title in the original language. Do not translate the product title to another language."
		}

		if (taskInputType === "description") {
			// return "Your job is to reword the following product description to make it more appealing to customers. The return format should be HTML. Do not include backticks as part of the response. Do not include the word html as part of the response."

			// return "You are a skilled at creating catchy, engaging e-commerce product descriptions. It starts with a compelling introduction within the first 25 words to capture the customer's attention. This is followed by highlighting three key features of the product, each introduced with an emoticon for visual appeal, using clear, approachable language for a broad audience. Sales Writer Pro avoids complex or unusual words, focusing on simplicity and clarity. The conclusion is concise, persuasive, and sales-driven, encouraging a purchase. When more product details are required, Sales Writer Pro requests specific information to create descriptions that are informative and enticing, focusing on creativity and brevity. While Sales Writer Pro previously considered incorporating illustrations and vectors in descriptions, it will now focus solely on text-based descriptions, ensuring clarity and precision without the use of additional visuals. Remember, the description must have at least 200 words. Improve the following description:"

			return `Design a product description for an e-commerce platform based on an existing product description that you will be given.
			The description should start with an engaging, compelling introduction of no more than 25 words, aimed at immediately capturing the customer's attention.
			This should be followed by three key features of the product, each introduced with a unique emoticon for visual appeal and described using clear, approachable language suitable for a broad audience.
			Then, include a conclusion. The conclusion must be concise, no more than 25 words, persuasive, and sales-driven, effectively encouraging the customer to make a purchase.
			Avoid complex or unusual words, emphasizing simplicity and clarity.
			Note that you will not incorporate any illustrations or vectors, to maintain clarity and precision.
			The HTML structure should include only paragraphs (<p> tags) with all text alignment to the left and only using black color for text.
			Use bold (<b> tags) for the titles of the key features and for the conclusion."
			Use a maximum of three emojis for the three key features. Do not include emojis anywhere else in the description.
			Do not include any backticks in the description. Do not include the word html in the description.
			Return the reworded description in the original language. Do not translate the description to another language.`
		}
	}

	if (taskName === "translate") {
		const languageName = getLanguageName(targetLang)

		if (taskInputType === "title") {
			return `Your job is to translate the following product title to ${languageName}. The return format should be a string. Do not return quotes as part of the response`
		}

		if (taskInputType === "description") {
			return `Your job is to translate the following product description to ${languageName}. The return format should be HTML.`
		}

		if (taskInputType === "variants") {
			return `Your job is to translate the following product variant titles to ${languageName}. 
			- For each element in the options and optionValues array, replace null in newName with the translated version of originalName. 
			- Do not remove the optionId property. 
			- Return only JSON. 
			- Return only in one line. 
			- Don't include newlines.
			- Don't translate internationalized sizing like 'XL', 'XXL', etc. unless the target language has a different way of representing them.'
			`
		}
	}
}
